var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "corner 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.0639 43.9689L11.4956 36.2168H27.6239C27.8159 36.7448 27.912 37.2967 27.912 37.8488C27.912 40.2729 26.0159 42.4809 23.0639 43.9689ZM47.3283 36.2168H30.12C30.24 36.7448 30.3121 37.2967 30.3121 37.8488C30.3121 40.8968 28.4159 43.6089 25.3439 45.505L46.6564 59.8092C47.4483 60.3132 48.5043 59.7613 48.5043 58.8252V37.3928C48.5043 36.7447 47.9764 36.2168 47.3283 36.2168ZM14.6637 0H12.3356C11.8795 0 11.4956 0.383944 11.4956 0.839962V33.8168H15.5277V0.839962C15.5277 0.383944 15.1437 0 14.6637 0ZM34.0561 2.18398C28.6799 3.14406 23.3038 0.888009 17.9277 1.43997V16.8724C23.4478 16.3203 28.944 18.6725 34.4641 17.5203C34.968 17.4244 35.3281 16.9443 35.3281 16.4164V3.28806C35.3281 2.59209 34.7281 2.06401 34.0561 2.18398Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorner);
export default __webpack_public_path__ + "static/media/corner.ac3fad1e27fe093df88feb2db3826cea.svg";
export { ForwardRef as ReactComponent };